import { createRuntimeOperationType, isRuntimeOperationConfig } from './common';
export const stringBuilderOperationType = createRuntimeOperationType({
    kind: 'STRING_BUILDER',
    dependencies: () => [],
    run: (value, context, operations) => {
        if (!Array.isArray(value)) {
            throw new Error(`STRING_BUILDER must be an array. Got ${JSON.stringify(value)}`);
        }
        if (value.some(isRuntimeOperationConfig)) {
            return value;
        }
        return value.join('');
    },
});
//# sourceMappingURL=string-builder.js.map